const date = new Date();
const year = date.getFullYear();

const APPCONFIG = {
  brand: 'iSMM',
  year,
  AutoCloseMobileNav: true,                         // true, false. Automatically close sidenav on route change (Mobile only)
  color: {
    primary: '#00BCD4',
    success: '#8BC34A',
    info: '#66BB6A',
    infoAlt: '#7E57C2',
    warning: '#FFCA28',
    danger: '#F44336',
    text: '#3D4051',
    gray: '#EDF0F1',

    appGreen: '#50E3C2',
    appPink: '#E91E64',
    appDarkGray: '#979797',
    appYellow: '#FFC107',
  },
  settings: {
    layoutBoxed: false,                             // true, false
    navCollapsed: false,                            // true, false
    navBehind: false,                               // true, false
    fixedHeader: true,                              // true, false
    sidebarWidth: 'middle',                         // small, middle, large
    colorOption: '14',                              // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    theme: 'light',                                 // light, gray, dark,
    logoUrl: 'assets/images/GHLogo.png'
  },
  apiUrl: process.env.API_URL,
  version: '3.3.66',
  apiVersion: '1.0',
  clientId: '3_2pzzew009vs4ggkc4cck8c4w8swgw0gg8ck08cww8oso80ooog',
  clientSecret: '1t1i0bdvso3okogw0ss00c8skg88kwcwwss8wo8g40kg480ko0',
  idleTimeout: 3600000,
  incmsDevUrl: 'https://backofficeprojectdata.com/fakeapi',
  incmsQaUrl: 'http://incmsqa.kplc.local',
  incmsProdUrl: 'http://incms.kplc.local',
  presenceInboundCallEvent: 'InboundCallEvent',
  presenceHangUpCallEvent: 'AfterCallWorkEvent',
  changePasswordUrl: 'http://incms.kplc.local/InCMSWeb-pman/#/InCMSWeb-pman/changePassword',
  QAchangePasswordUrl: 'http://incmsqa.kplc.local/InCMSWeb-pman/#/InCMSWeb-pman/changePassword',
  PROchangePasswordUrl: 'http://incms.kplc.local/InCMSWeb-pman/#/InCMSWeb-pman/changePassword',
  DEVchangePasswordUrl: 'http://incmsdev.kplc.local/InCMSWeb-pman/#/InCMSWeb-pman/changePassword',
  mapKey: '123'
};

module.exports = APPCONFIG;



// WEBPACK FOOTER //
// ./constants/Config.js